import React from 'react';
import { ModalBody, ModalHeader } from 'baseui/modal';
import CustomModal from 'presentation/components/modal/CustomModal';
import CustomModalFooter from 'presentation/components/modal/CustomModalFooter';
import { Col, Container, Row } from 'react-bootstrap';
import { Button } from '@techem/ui-components';
import { KIND, SIZE } from 'baseui/button';
import { TrackerUtil } from 'tracking/TrackerUtil';
import FullOperatingCostsModalContent from 'presentation/components/shared/FullOperatingCostsModalContent';
import { useStyletron } from 'baseui';
import { useTranslation } from 'react-i18next';

interface FullOperatingCostsModalProps {
  isOpen: boolean;
  onClose: () => void;
  onAccept: () => void;
  onDecline: () => void;
  price: string;
}

const FullOperatingCostsModal: React.FC<FullOperatingCostsModalProps> = ({
  isOpen,
  onClose,
  onAccept,
  onDecline,
  price
}) => {
  const { t } = useTranslation();
  const [css] = useStyletron();
  return (
    <CustomModal
      isOpen={isOpen}
      modalId="modal-full-operating-costs"
      onClose={() => {
        TrackerUtil.trackBtnClickByIdentifier('close', 'modal-full-operating-costs');
        onClose();
      }}
      additionalTestId="full-operating-costs"
    >
      <ModalHeader style={{ paddingRight: '1rem' }}>
        <h3
          className={css({
            whiteSpace: 'normal',
            overflowWrap: 'break-word'
          })}
        >
          {t('fullOperatingCostsModalTitle')}
        </h3>
      </ModalHeader>
      <ModalBody>
        <FullOperatingCostsModalContent />
      </ModalBody>
      <CustomModalFooter>
        <Container fluid>
          <Row className="justify-content-between">
            <Col xs={12} md="auto" className="d-flex">
              <span
                className="pt-2 pb-4 py-md-0 py-lg-0 m-auto fw-bold fs-6 text-center"
                style={{ color: '#222', lineHeight: '18px' }}
              >
                {t('fullOperatingCostsModalBookingQuestionPrefix')} {price}{' '}
                {t('fullOperatingCostsModalBookingQuestionSuffix')}
              </span>
            </Col>
            <Col xs={12} md="auto">
              <Row className="justify-content-center">
                <Col
                  xs={12}
                  sm="auto"
                  className="my-2 my-md-0 order-last order-sm-first text-center"
                >
                  <Button
                    kind={KIND.secondary}
                    size={SIZE.large}
                    onClick={onDecline}
                    additionalTestId="decline"
                    trackClickUsingTestId={(buttonIdentifier) =>
                      TrackerUtil.trackBtnClickByIdentifier(
                        buttonIdentifier,
                        'modal-full-operating-costs'
                      )
                    }
                  >
                    {t('fullOperatingCostsModalBookingAnswerNo')}
                  </Button>
                </Col>
                <Col xs="auto" className="my-2 my-md-0 text-center">
                  <Button
                    size={SIZE.large}
                    onClick={onAccept}
                    additionalTestId="accept"
                    trackClickUsingTestId={(buttonIdentifier) =>
                      TrackerUtil.trackBtnClickByIdentifier(
                        buttonIdentifier,
                        'modal-full-operating-costs'
                      )
                    }
                  >
                    {t('fullOperatingCostsModalBookingAnswerYes')}
                  </Button>
                </Col>
              </Row>
            </Col>
          </Row>
        </Container>
      </CustomModalFooter>
    </CustomModal>
  );
};

export default FullOperatingCostsModal;
